import type { Route42Membership } from './types';

export function isOrganizationSuspended(membership: Route42Membership): boolean {
  return membership.customer_status === 'SUSPENDED';
}

export function isMembershipSuspended(membership: Route42Membership): boolean {
  return membership.membership_status === 'SUSPENDED';
}

export function hasUnavailableOrganizationAccess(membership: Route42Membership): boolean {
  if (membership.membership_status !== 'ACTIVE' && membership.membership_status !== 'SUSPENDED') return false;
  return isOrganizationSuspended(membership) || isMembershipSuspended(membership);
}

export function organizationSwitcherMemberships(memberships: readonly Route42Membership[]): Route42Membership[] {
  return memberships.filter((membership) => membership.access_available || hasUnavailableOrganizationAccess(membership));
}
